import { types } from 'mobx-state-tree';


const EMPLOYMENT_TYPES = {
    FULL_TIME: 'full-time',
    PART_TIME: 'part-time',
    SEASONAL: 'seasonal',
};

const EmploymentTypeEnum = types.enumeration('EmploymentType', Object.values(EMPLOYMENT_TYPES));

export {
    EmploymentTypeEnum,
};
export default EMPLOYMENT_TYPES;
